module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-dots"
  }, [_c('div', {
    staticClass: "loader-dots-dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader-dots-dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader-dots-dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader-dots-dot"
  }), _vm._v(" "), _c('div', {
    staticClass: "loader-dots-dot"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8bf99b82"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoaderDots.vue
// module id = 446
// module chunks = 1